
const state = {
  fetched: false
}

const getters = {
  allEvents: (state, getters) => getters.query().get()
}

const actions = {
  async addEvent ({ dispatch }, { title, dateStart, description }) {
    if (!title || !dateStart) return
    if (!description || description.length === 0) {
      description = title
    }
    let result = {}
    try {
      const newChannel = await this.getters.api.post('/channels', {
        data: {
          channel: {
            title,
            event_date: dateStart,
            description
          }
        }
      })
      if (newChannel && newChannel.data && newChannel.data.channel) {
        dispatch('insert', { data: [newChannel.data.channel] })
        result.success = true
      } else {
        throw newChannel
      }
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        result.error = e.response.data.error
      }
    }
    return result
  },
  async ensureEvents ({ state, dispatch }) {
    if (!state.fetched) {
      dispatch('fetchEvents')
    }
  },
  async fetchEvents ({ dispatch, commit }) {
    let result = {}
    try {
      const fetch = await this.getters.api.get('/channels', {
        params: {
          scope: 'view'
        }
      })
      dispatch('create', { data: fetch.data.channels })
      commit('fetched', true)
      result.success = true
    } catch (e) {
      console.log('response: ', e)
      if (e.response && e.response.data && e.response.data.error) {
        result.error = e.response.data.error
      }
    }
    return result
  }
}

const mutations = {
  fetched (state, value) {
    state.fetched = true
  },
  reset (state, initial) {
    Object.keys(initial).forEach(key => {
      state[key] = initial[key]
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
